import { Box, Button, Checkbox, Flex } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { useEffect, useState } from "react";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { modifyItemFeature } from "../../../../api/ApiProduct";
import LoadingOverlayCustom from "../../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { featureOption, TblItemCommand } from "../../../../model/ProductList";

type Props = {
  data: TblItemCommand[];
  IdSp: number;
  fetchData?: () => void;
};

const UpdateCharacteristicsModal = ({ data, IdSp, fetchData }: Props) => {
  const dataDetailNew = data.filter((item) => item.id === IdSp);

  if (!dataDetailNew || dataDetailNew.length === 0) {
    modals.closeAll();
    setTimeout(() => {
      NotificationExtension.Fails("Không tìm thấy sản phẩm!");
    }, 0);
  }
  const [feature, setFeature] = useState<featureOption[]>([]);
  const [visible, { toggle, close, open }] = useDisclosure(false);

  //   Hàm để cập nhật trạng thái đặc điểm sản phẩm
  const handleUpdateStatus = async () => {
    open();
    try {
      const data = feature.find((item) => item.id === dataDetailNew[0].id);
      if (data) {
        await modifyItemFeature(data);
      } else
        NotificationExtension.Warn(
          "Xin vui lòng cập nhật đặc điểm cho sản phẩm!"
        );
    } catch (error) {
      console.log("error", error);
    } finally {
      fetchData && fetchData();
      modals.closeAll();
      close();
    }
  };

  //   Hàm để xử lý thay đổi trạng thái đặc điểm sản phẩm
  const handleChangeFeature = (value: string, checked: boolean, id: number) => {
    setFeature((prevFeature) => {
      return prevFeature.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            [value]: checked ? "Y" : "N",
          };
        }
        return item;
      });
    });
  };

  useEffect(() => {
    setFeature(
      data.map((item) => ({
        id: item.id,
        hotStatus: item.hotStatus || "N",
        newStatus: item.newStatus || "N",
        bestSaleStatus: item.bestSaleStatus || "N",
        saleOffStatus: item.saleOffStatus || "N",
        onlineStatus: item.onlineStatus || "N",
      }))
    );
  }, [data]);

  return (
    <>
      <Box
        display={"flex"}
        style={{
          flexDirection: "row",
          marginTop: "15px",
          gap: "20px",
          alignItems: "center",
        }}
        pos={"relative"}
      >
        <LoadingOverlayCustom visible={visible} />
        <Checkbox
          value="newStatus"
          label="Mới"
          mb={"xs"}
          defaultChecked={dataDetailNew[0].newStatus === "Y" ? true : false}
          onChange={(event) =>
            handleChangeFeature(
              "newStatus",
              event.currentTarget.checked,
              dataDetailNew[0].id
            )
          }
        />
        <Checkbox
          value="hotStatus"
          label="HOT (hỏi nhiều)"
          mb={"xs"}
          defaultChecked={dataDetailNew[0].hotStatus === "Y" ? true : false}
          onChange={(event) =>
            handleChangeFeature(
              "hotStatus",
              event.currentTarget.checked,
              dataDetailNew[0].id
            )
          }
        />
        <Checkbox
          value="bestSaleStatus"
          label="Bán chạy"
          mb={"xs"}
          defaultChecked={
            dataDetailNew[0].bestSaleStatus === "Y" ? true : false
          }
          onChange={(event) =>
            handleChangeFeature(
              "bestSaleStatus",
              event.currentTarget.checked,
              dataDetailNew[0].id
            )
          }
        />
        <Checkbox
          value="saleOffStatus"
          label="Xả hàng (sale-off)"
          mb={"xs"}
          defaultChecked={dataDetailNew[0].saleOffStatus === "Y" ? true : false}
          onChange={(event) =>
            handleChangeFeature(
              "saleOffStatus",
              event.currentTarget.checked,
              dataDetailNew[0].id
            )
          }
        />
        <Checkbox
          value="onlineStatus"
          label="Chỉ bán online"
          mb={"xs"}
          defaultChecked={dataDetailNew[0].onlineStatus === "Y" ? true : false}
          onChange={(event) =>
            handleChangeFeature(
              "onlineStatus",
              event.currentTarget.checked,
              dataDetailNew[0].id
            )
          }
        />
      </Box>
      <Flex direction={"row"} justify="flex-end" mt="md">
        <Button onClick={() => handleUpdateStatus()}>Cập nhật</Button>
      </Flex>
    </>
  );
};

export default UpdateCharacteristicsModal;
